import Application from '../../../application'
export default {
    mounted() {
        this.getAllSchools()
    },
    data: () => ({
        currentStep: 1,
        //Schools
        schoolsHeaders: [
            {
                text: 'Región',
                align: 'left',
                value: 'REGION_NAME'
            },
            {
                text: 'Escuela',
                align: 'left',
                value: 'SCHOOL_NAME'
            },
            {
                text: 'Código de Escuela',
                align: 'left',
                value: 'SCHOOL_CODE'
            },
            {
                text: 'Certificación Mayo',
                align: 'left',
                sortable: false,
                value: 'SCHOOL_CODE'
            },
            {
                text: 'Certificación Verano',
                align: 'left',
                sortable: false,
                value: 'SCHOOL_CODE'
            }
        ],
        searchSchools: '',
        schoolsLoading: true,
        schools: []
    }),
    methods: {
        getAllSchools() {
            var self = this
            self.schoolsLoading = true
            this.$ajax.get("/CERTIFIED_SCHOOLS/GetAllCertifiedsSchools").then(response => {
                self.schools = response.data
                self.schoolsLoading = false
            }).catch(response => {
                self.schoolsLoading = false
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        },
        downloadReportProgreso() {
            window.open(Application.BaseUrl + '/ReportingServicesReports/GetGraduadosCertificadosProgresoReport')
        },
        deleteSchoolCertification(props) {
            var self = this
            self.$root.$confirm('Confirme', '¿Seguro que quieres borrar el registro?')
                .then(result => {
                    if (result) {
                        self.$ajax.post("/CERTIFIED_SCHOOLS/Delete", { CERTIFIED_SCHOOLS_ID_PK: props.item.CERTIFIED_SCHOOLS_ID_PK }).then(response => {
                            self.schools.splice(props.index, 1)
                            self.$root.$snackbar('¡El registro ha sido eliminado con éxito!', { color: 'success' })
                        }).catch(response => {
                            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
                        })
                    }
                })
            
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/graduados/certificaciones/script.js